import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StateService {

  contextVars: string[] = []

  constructor() { }
}
